import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=68f51755&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"
import style0 from "./Tabs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Tabs.vue?vue&type=style&index=1&id=68f51755&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f51755",
  null
  
)

export default component.exports